import type { AutoBattleMode, AutoBattleModeEntitlements, Hero } from "../types";

export function resolveAutoBattlePrefs(hero: Hero | null | undefined) {
  return {
    mode: (hero?.auto_battle?.mode ?? "rotation") as AutoBattleMode,
    prompt_on_start: hero?.auto_battle?.prompt_on_start ?? true,
    tactical_skills: hero?.auto_battle?.tactical_skills ?? null,
  };
}

export function resolveAutoBattleEntitlements(
  hero: Hero | null | undefined,
): AutoBattleModeEntitlements {
  const fromPrefs = hero?.auto_battle?.mode_entitlements;
  if (fromPrefs) {
    return {
      tactician: Boolean(fromPrefs.tactician),
      strategist: Boolean(fromPrefs.strategist),
    };
  }
  const fromPremium = hero?.premium?.auto_battle;
  if (fromPremium) {
    return {
      tactician: Boolean(fromPremium.tactician),
      strategist: Boolean(fromPremium.strategist),
    };
  }
  return { tactician: false, strategist: false };
}

export function isAutoBattleModeAllowed(
  id: AutoBattleMode,
  entitlements: AutoBattleModeEntitlements,
): boolean {
  if (id === "tactician") return entitlements.tactician;
  if (id === "strategist") return entitlements.strategist;
  return true;
}
